/*
 * @Descripttion: 支持单选的复选框
 * @Author: renbh
 * @Date: 2023-06-14 16:17:27
 * @LastEditors: renbh
 * @LastEditTime: 2023-06-14 16:24:32
 */

import { Checkbox } from 'antd'
import { CheckboxValueType } from 'antd/lib/checkbox/Group'

interface Props {
  value?: string
  onChange?: (value: string) => void
  dataSource: readonly {
    key: string
    value: string
    [x: string]: any
  }[]
  readOnly?: boolean
}

const SingleAbleCheckbox = (props: Props) => {
  const { value, onChange, dataSource, readOnly = false } = props

  const handleChange = (checkedValue: CheckboxValueType[]) => {
    if (checkedValue.length > 1) {
      checkedValue.shift()
    }
    onChange?.(checkedValue.join())
  }

  return (
    <Checkbox.Group onChange={handleChange} value={value?.split('')}>
      {dataSource.map((item) => (
        <Checkbox value={item.key} key={item.key} disabled={readOnly}>
          {item.value}
        </Checkbox>
      ))}
    </Checkbox.Group>
  )
}

export default SingleAbleCheckbox
/*
 * @Descripttion: 支持单选的复选框
 * @Author: renbh
 * @Date: 2023-06-14 16:17:27
 * @LastEditors: renbh
 * @LastEditTime: 2023-06-14 16:24:32
 */

import { Checkbox } from 'antd'
import { CheckboxValueType } from 'antd/lib/checkbox/Group'

interface Props {
  value?: string
  onChange?: (value: string) => void
  dataSource: readonly {
    key: string
    value: string
    [x: string]: any
  }[]
  readOnly?: boolean
}

const SingleAbleCheckbox = (props: Props) => {
  const { value, onChange, dataSource, readOnly = false } = props

  const handleChange = (checkedValue: CheckboxValueType[]) => {
    if (checkedValue.length > 1) {
      checkedValue.shift()
    }
    onChange?.(checkedValue.join())
  }

  return (
    <Checkbox.Group onChange={handleChange} value={value?.split('')}>
      {dataSource.map((item) => (
        <Checkbox value={item.key} key={item.key} disabled={readOnly}>
          {item.value}
        </Checkbox>
      ))}
    </Checkbox.Group>
  )
}

export default SingleAbleCheckbox
